import React, { ReactElement, ReactNode } from 'react';
import { Box, SxProps, Theme } from '@mui/material';
import { useImpressionTracker } from 'hooks/useImpressionTracker';

export interface TrackEventImpressionProps {
  eventId: string | undefined;
  children: ReactNode;
  sx?: SxProps<Theme>;
}

/**
 * Wraps a public event card so the first time it dwells on screen for ~1s
 * the impression is queued and batched into POST /events/impressions.
 * Use only on user-facing discovery surfaces — not on admin / request /
 * ticket-owner views.
 */
export const TrackEventImpression = ({
  eventId,
  children,
  sx,
}: TrackEventImpressionProps): ReactElement => {
  const ref = useImpressionTracker(eventId);
  return (
    <Box ref={ref} sx={sx}>
      {children}
    </Box>
  );
};
